<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Order Detail</h2>
          </header>
        </div>
      </div>
      <div class="inputCard" v-if="loaded">
        <header>Order ID: {{selectedOrder.id}}</header>
        <div class="content">
          <div class="w3-row w3-border-left w3-border-right">
            <div class="w3-col s12 m6">
              <div class="w3-padding">
                <b>Billing</b>
                <div>{{selectedOrder.billingAddress.email}}</div>
                <div>{{selectedOrder.billingAddress.firstname}} {{selectedOrder.billingAddress.lastname}}</div>
                <div v-if="selectedOrder.company">{{selectedOrder.company}}</div>
                <div>{{selectedOrder.billingAddress.address1}}</div>
                <div v-if="selectedOrder.billingAddress.address2">{{selectedOrder.billingAddress.address2}}</div>
                <div>{{selectedOrder.billingAddress.city}}, {{selectedOrder.billingAddress.state}}  {{selectedOrder.billingAddress.zip}}</div>
              </div>
            </div>
            <div class="w3-col s12 m6">
              <div class="w3-padding">
                <b>Shipping</b>
                <div>{{selectedOrder.shippingAddress.firstname}} {{selectedOrder.shippingAddress.lastname}}</div>
                <div v-if="selectedOrder.company">{{selectedOrder.company}}</div>
                <div>{{selectedOrder.shippingAddress.address1}}</div>
                <div v-if="selectedOrder.shippingAddress.address2">{{selectedOrder.shippingAddress.address2}}</div>
                <div>{{selectedOrder.shippingAddress.city}}, {{selectedOrder.shippingAddress.state}}  {{selectedOrder.shippingAddress.zip}}</div>
              </div>
            </div>
            <div class="w3-col s12">
              <div class="w3-padding">
                <div>Status: {{selectedOrder.status}}</div>
                <div>Created: {{selectedOrder.created}}</div>
                <div v-if="selectedOrder.shipped">Shipped: {{selectedOrder.shipped}}</div>
              </div>
            </div>
          </div>
          <div class="w3-row w3-padding w3-dark-grey">
            <div class="w3-col s6">Item</div>
            <div class="w3-col s3 w3-right-align">Qty</div>
            <div class="w3-col s3 w3-right-align">Total</div>
          </div>
          <div class="w3-row w3-padding w3-border-bottom w3-border-left w3-border-right" v-for="(orderItem, index) in selectedOrder.items" :key="index">
            <div class="w3-col s6">{{orderItem.title}}</div>
            <div class="w3-col s3 w3-right-align">{{orderItem.quantity}}</div>
            <div class="w3-col s3 w3-right-align">{{orderItem.price | currency}}</div>
          </div>
          <!-- <div class="w3-row w3-padding w3-border-bottom w3-border-left w3-border-right">
            <div class="w3-col s6">Tax</div>
            <div class="w3-col s6 w3-right-align">{{selectedOrder.tax}}</div>
          </div> -->
          <div class="w3-row w3-padding w3-border-bottom w3-border-left w3-border-right">
            <div class="w3-col s6">Subtotal</div>
            <div class="w3-col s6 w3-right-align">{{selectedOrder.subtotal | currency}}</div>
          </div>
          <div class="w3-row w3-padding w3-border-bottom w3-border-left w3-border-right">
            <div class="w3-col s6">Shipping</div>
            <div class="w3-col s6 w3-right-align">{{(selectedOrder.total / 100) - selectedOrder.subtotal | currency}}</div>
          </div>
          <div class="w3-row w3-padding w3-border-bottom w3-border-left w3-border-right">
            <div class="w3-col s6">Total</div>
            <div class="w3-col s6 w3-right-align"><b>{{(selectedOrder.total / 100) | currency}}</b></div>
          </div>
        </div>
      </div>
      <!-- <div class="inputCard">
        <header>Pending</header>
        <div class="content">
          Test
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsproductorderdetail',
  data() {
    return {
      state: dataStore.state,
      loaded: false,
      selectedOrder: {}
    }
  },
  created() {
    if (this.state.selectedOrder !== 0) {
      dataStore.getOrders().then((res) => {
        if (res === 'success') {
          for (let orderItem of this.state.siteData.content.products.orders) {
            if (this.state.selectedOrder === orderItem.id) {
              console.log(orderItem)
              let subtotal = 0
              for (let subItem of orderItem.items) {
                subtotal += subItem.price * subItem.quantity
              }
              orderItem.subtotal = subtotal
              this.selectedOrder = orderItem
              this.loaded = true
            }
          }
        } else {
          console.log('couldnt get orders...')
        }
      })
    }
  },
  methods: {
    gotoPage(page) {
      if (page === '-1') {
        if (this.activePage > 1) {
          this.activePage--
        }
      } else if (page === '+1') {
        if (this.activePage < Math.ceil(this.state.siteData.content.products.items.length / 9)) {
          this.activePage++
        }
      } else {
        this.activePage = page
      }
    },
    setParent(parent) {
      this.newCategory.parentid = parent.id
    },
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000)
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var year = a.getFullYear()
      var month = months[a.getMonth()]
      var date = a.getDate()
      var hour = a.getHours()
      var min = a.getMinutes() < 10 ? '0' + a.getMinutes() : a.getMinutes()
      // var sec = a.getSeconds() < 10 ? '0' + a.getSeconds() : a.getSeconds()
      // var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec
      // TODO: change to 12 hour time with AM/PM
      var time = month + ' ' + date + ', ' + year + ' ' + hour + ':' + min
      return time
    }
  }
}
</script>

<style scoped>
  .orderRow {display:grid; grid-template-columns: 90px 300px 200px 1fr 200px 150px 150px; grid-gap:8px; font-family: 'Roboto';}
  .orderRow .orderCol {padding:4px 8px;}
  .itemRow:nth-child(even) {background:#eee;}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsProductOrderDetail.vue